<template>
  <div class="tw:bg-blue-200 tw:w-full tw:flex tw:py-4 tw:md:py-12">
    <div
      class="tw:flex tw:flex-col tw:justify-center tw:items-start tw:mx-auto tw:w-full tw:md:px-4 tw:md:max-w-screen-lg tw:lg:max-w-screen-xl"
    >
      <h1 class="tw:hidden tw:md:flex tw:text-[44px] tw:leading-[55px] tw:font-bold tw:mb-8">
        {{ $t('plus_insights_welcome') }}
      </h1>
      <div
        class="tw:flex tw:gap-x-3 tw:w-full tw:overflow-x-auto tw:md:overflow-x-visible tw:md:pb-0 tw:px-4 tw:md:px-0"
      >
        <PropertyInfoCard class="tw:min-w-[80vw] tw:flex-shrink-0 tw:md:min-w-0 tw:md:flex-[2]" />
        <PromoBadgeCard class="tw:min-w-[80vw] tw:flex-shrink-0 tw:md:min-w-0 tw:md:flex-1" />
        <ContactInfoCard class="tw:min-w-[80vw] tw:flex-shrink-0 tw:md:min-w-0 tw:md:flex-1" />
      </div>
    </div>
  </div>
</template>
<script setup>
import PropertyInfoCard from '@/components/studioPlus/insights/PropertyInfoCard.vue'
import PromoBadgeCard from '@/components/studioPlus/insights/PromoBadgeCard.vue'
import ContactInfoCard from '@/components/studioPlus/insights/ContactInfoCard.vue'
</script>
